// firebase-config.js

// Import compat SDK
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/analytics';
import 'firebase/compat/storage';

// Import modular SDK for named Firestore database
import { initializeApp } from 'firebase/app';
import { getFirestore as getNamedFirestore } from 'firebase/firestore';

// Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyBQac5PZqqfD1BO21iRLUASoemsJGBxBH0",
  authDomain: "spried-bb41e.firebaseapp.com",
  projectId: "spried-bb41e",
  storageBucket: "spried-documents",
  messagingSenderId: "559502217297",
  appId: "1:559502217297:web:3c4053d9c412ffd6c6a870",
  measurementId: "G-ZFRRB02E05"
};

// Initialize compat SDK (for react-redux-firebase)
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
  firebase.analytics();
}

// Initialize modular app (for named Firestore)
const modularApp = initializeApp(firebaseConfig);
const db = getNamedFirestore(modularApp, 'spried-iot');

// Override compat firestore() to use named instance
firebase.firestore = () => db;

// Export everything
const auth = firebase.auth();
const storage = firebase.storage();

export default firebase;
export { db, auth, storage };
